<!--
  KPE-865: Displays loading state during OAuth callback processing.
-->
<div class="center-block" style="width:200px;">Redirecting to Home Page ...</div>